import React from 'react';
import { withAnalyticsAppContext } from '../../../context/analytics-app-context';
import { isEmpty } from '../../../utils/object-utils';
import './analytics-over-time-table.scss';
import AnalyticsTable from '../../analytics-table/AnalyticsTable';

function AnalyticsOverTimeTable({ appContext }) {
    const { loading } = appContext;
    const { analyticsOverTimeData } = appContext.analyticsData || {};
    let firstElement = analyticsOverTimeData ?
        analyticsOverTimeData[Object.keys(analyticsOverTimeData)[0]]
            ? analyticsOverTimeData[Object.keys(analyticsOverTimeData)[0]].categories : [] : [];

    const analyticsOverTimeProperties = [
        { property: 'dateText', headerText: 'Day', isProgressBar: false },
        { property: 'timeText', headerText: 'Time', isProgressBar: false },
        { property: 'activeVisitors', headerText: 'Active Visitors', isProgressBar: false },
    ];
    firstElement.forEach(category => {
        analyticsOverTimeProperties.push(
            {
                property: 'categories',
                arrayKey: 'categoryName',
                arrayValue: category.categoryName,
                arrayProperty: "numberOfAcceptedCookies",
                headerText: category.categoryName,
                isProgressBar: false
            },
        );
    });

    return (
        <div className='analytics-grid-item-root analytics-grid-over-time-root analytics-component grid-item'>
            <div className='analytics-grid-item-data'>
                <div className='card-header-root'>
                    <div className='card-header-content'>
                        <span className='card-header-title'>
                            <h6> {'Analytics over time'}</h6>
                        </span>
                    </div>
                </div>

                <div className='card-body'>
                    {loading && 'Loading...'}
                    {loading || isEmpty(analyticsOverTimeData) ?
                        null :
                        <AnalyticsTable
                            tableProperties={analyticsOverTimeProperties}
                            tableData={Object.values(analyticsOverTimeData)}></AnalyticsTable>}
                </div>
            </div>
        </div>
    );
}

export default withAnalyticsAppContext(AnalyticsOverTimeTable);
